export enum LicenseType {
  ROYALTY_FREE = 'royalty-free',
  ROYALTIES_APPLIED = 'artist-voices',
  PRIVATE = 'private',
  INSTRUMENT = 'instrument'
}

export enum PublishStatus {
  PRIVATE = 'private',
  PUBLIC = 'public'
}
